import apiClient from './api-client'

export interface OrganizationalUnit {
  ou_code: string
  ou_name: string
  ou_logo?: string
  description?: string
  level?: number
  parent_ou_code?: string
}

export interface OUAccessResponse {
  status: boolean
  data: OrganizationalUnit[]
  meta?: {
    total: number
    is_super_admin: boolean
    default_ou_code?: string
  }
}

export interface OUDetailsResponse {
  status: boolean
  data: {
    ou: OrganizationalUnit
    permissions: Record<string, string[]>
  }
}

export interface OUValidationResponse {
  status: boolean
  has_access: boolean
  ou?: OrganizationalUnit
}

const ouService = {
  /**
   * Get all OUs accessible by current user
   */
  async getAccessibleOUs(): Promise<OUAccessResponse> {
    const response = await apiClient.get('/ou-access')
    return response.data
  },

  /**
   * Get OU details with permissions
   */
  async getOUDetails(ouCode: string): Promise<OUDetailsResponse> {
    const response = await apiClient.get(`/ou-access/${ouCode}`)
    return response.data
  },

  /**
   * Validate if user can access specific OU
   */
  async validateAccess(ouCode: string): Promise<OUValidationResponse> {
    const response = await apiClient.post('/ou-access/validate', { ou_code: ouCode })
    return response.data
  },

  /**
   * Clear OU cache (call after role/permission changes)
   */
  async clearCache(): Promise<{ status: boolean; message: string }> {
    const response = await apiClient.post('/ou-access/clear-cache')
    return response.data
  },
}

export default ouService
